import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const Footer = ({
  save,
  saveText = "Save",
  buttons = [],
  confirmBackMessage = "Are you sure you want to leave this page? Unsaved changes will be lost.",
  showBackConfirmation = true, // New prop with default true
  showSave = true,
}) => {
  const navigate = useNavigate();
  const [showBackConfirmModal, setShowBackConfirmModal] = useState(false);

  const handleBack = () => {
    // If showBackConfirmation is false, directly navigate back
    if (!showBackConfirmation) {
      navigate(-1);
      return;
    }

    // If save function exists and showBackConfirmation is true, show modal
    if (save) {
      setShowBackConfirmModal(true);
    } else {
      // If no save function, simply go back
      navigate(-1);
    }
  };

  const confirmBack = () => {
    setShowBackConfirmModal(false);
    navigate(-1);
  };

  return (
    <>
      <footer className="footer" style={{ padding: "0px" }}>
        <div className="d-flex gap-3 align-items-center justify-content-center">
          <Button
            color="secondary"
            outline
            className="waves-effect waves-light rounded-3"
            onClick={handleBack}
          >
            Back
          </Button>

          {showSave && (
            <Button
              color="primary"
              outline
              className="waves-effect waves-light me-2 bg-primary text-white rounded-3"
              onClick={() => {
                save && save();
              }}
            >
              {saveText}
            </Button>
          )}

          {buttons.map((button, index) => (
            <Button
              key={index}
              color={button.color || "primary"}
              outline={button.outline !== undefined ? button.outline : true}
              className="waves-effect waves-light me-2 bg-primary text-white rounded-3"
              onClick={button.onClick}
            >
              {button.text}
            </Button>
          ))}
        </div>
      </footer>

      {/* Back Confirmation Modal */}
      <Modal
        isOpen={showBackConfirmModal}
        toggle={() => setShowBackConfirmModal(false)}
        className="bg-white rounded-3"
      >
        <ModalHeader toggle={() => setShowBackConfirmModal(false)}>
          Are you sure ?
        </ModalHeader>
        <ModalBody>{confirmBackMessage}</ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            className="rounded-3"
            onClick={() => setShowBackConfirmModal(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            className="waves-effect waves-light me-2 bg-primary text-white rounded-3"
            onClick={confirmBack}
          >
            Leave
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Footer;
